exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tableCard[data-v-0e5dcafa] {\n  margin-bottom: 4px;\n}\n.tableCard .text[data-v-0e5dcafa] {\n    background-color: #ecf5ff;\n    color: #409eff;\n    border: 1px solid #d9ecff;\n    padding: 0 10px;\n    line-height: 20px;\n}\n", ""]);

// exports
